module.exports = __webpack_public_path__ + "img/4-mov.228c3146.png";